import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";


export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{
        minHeight: "100vh",
        background: "#0c0c0f",
        display: "grid",
        placeItems: "center",
      }}>
        <div style={{
          width: 32,
          height: 32,
          border: "2px solid rgba(124,106,247,0.3)",
          borderTopColor: "#7c6af7",
          borderRadius: "50%",
          animation: "spin 0.6s linear infinite",
        }} />
        <style>{`@keyframes spin { to { transform: rotate(360deg); }}`}</style>
      </div>
    );
  }

  return user ? children : <Navigate to="/" replace />;
  
}
